module.exports = __webpack_public_path__ + "img/electronic_electric_reserved_selected.64438af2.svg";